import http from "@/services/http";
import {INSTITUTION_URL} from "@/services/endpoints";

export function  getInstitutionList(params) {
  return http.request({
    url:INSTITUTION_URL,
    method:'get',
    params
  })
}
export function  fetchInstitution(id) {
  return http.request({
    url:INSTITUTION_URL+`/${id}`,
    method:'get',
  })
}
export function createInstitution(postData){
  return http.request({
    url:INSTITUTION_URL,
    method:'post',
    data:postData
  })
}
export function  updateInstitution(id, data) {
  return http.request({
    url:INSTITUTION_URL+`/${id}`,
    method:'put',
    data
  })
}
export function  deleteInstitution(id) {
  return http.request({
    url:INSTITUTION_URL+`/${id}`,
    method:'delete',
  })
}
